"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var ui_1 = require("@vidazoo/ui");
var _ = require("lodash");
var theme = require("../../styles/baseForm.scss");
var ViewAsList = /** @class */ (function (_super) {
    tslib_1.__extends(ViewAsList, _super);
    function ViewAsList(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onSelectUser = function (user) {
            _this.setState({ selectedUser: user });
        };
        _this.onViewAs = function () {
            var selectedUser = _this.state.selectedUser;
            window.__sdk__.auth.viewAs(selectedUser);
        };
        _this.state = { selectedUser: "" };
        return _this;
    }
    ViewAsList.prototype.componentWillMount = function () {
        var getUsersToViewAs = this.props.getUsersToViewAs;
        getUsersToViewAs();
    };
    ViewAsList.prototype.renderLoader = function () {
        return (React.createElement("div", null,
            React.createElement(ui_1.Loader, { size: 1, gray: true }),
            React.createElement(ui_1.PageMessage, { small: true, title: "Loading users to view as", description: "Please wait..." })));
    };
    ViewAsList.prototype.render = function () {
        var usersToViewAs = this.props.usersToViewAs;
        var props = {
            onSelectionChange: this.onSelectUser,
            value: this.state.selectedUser,
            surfaceLevel: 0,
            maxItems: 5,
            searchable: true,
            multiple: false,
            required: true,
            focus: true
        };
        return (React.createElement("div", null,
            (usersToViewAs && usersToViewAs.length > 0) ? (React.createElement(ui_1.FormMultiSelect, tslib_1.__assign({}, props), _.map(usersToViewAs, function (user) {
                return (React.createElement(ui_1.MultiSelectOption, { label: user.label, value: user.email, key: user._id }));
            }))) : this.renderLoader(),
            React.createElement("div", { className: theme.actions },
                React.createElement(ui_1.Button, { disabled: !this.state.selectedUser, type: "submit", blue: true, medium: true, uppercase: true, onClick: this.onViewAs }, "View As " + this.state.selectedUser))));
    };
    return ViewAsList;
}(React.Component));
exports.default = ViewAsList;
